import { render, staticRenderFns } from "./FirstStep.vue?vue&type=template&id=3973b647"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputValidationInput: require('/usr/src/app/components/input/ValidationInput.vue').default,Form: require('/usr/src/app/components/form/index.vue').default})
